import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ResponsiveEmbed from 'react-responsive-embed';
import axios from 'axios';
import translations from '../translations';

const VideoId = () => {
  const { id } = useParams();
  const [url, setUrl] = useState('');
  const [card, setCard] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState('U4i_pEsQFz4');
  const [startTime, setStartTime] = useState('0');
  const [playVideo, setPlayVideo] = useState(true);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  const cardUrl = `${process.env.REACT_APP_APP_BASE_URL}/invite/${id}`;

  const videoIds = [
    { id: 'U4i_pEsQFz4', title: t.aThousandYears },
    { id: '7rc2y2P5BgQ', title: t.beautifulInWhite },
    { id: '82vC07ygl0A', title: t.perfect },
    { id: 'bbAurDvlikM', title: t.youAreTheReason },
    // { id: 'MLDHyBVVAbA', title: 'Saat Bahagia' },
    // { id: 'hl4VRYKqFN8', title: 'Berakhirlah Penantianku' },
    // { id: 'B5XDa4QqP_E', title: 'Memori Tercipta' },
    // { id: 'CzoCeMsa66U', title: 'Kau Tercipta' },
    // { id: 's_FQB8odeyc', title: 'Satu Shaf Di Belakangku' },
    // { id: 'yppqxahvYCk', title: 'Di Renjis Renjis' },
    // { id: 'P74C6cOuKv4', title: 'Selamat Pengantin Baru' },
    // { id: 'dAtFzidmmsg', title: 'Kompang Dipalu' },
  ];

  const extractVideoId = () => {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);

    if (match && match[1]) {
      setSelectedVideoId(match[1]);
      setPlayVideo(true); // Set to true to play the video
      setCard(false);
    } else {
      setSelectedVideoId('Invalid URL or Video ID not found');
      setPlayVideo(false); // Set to false to stop playing the video
    }
  };

  const handleVideoButtonClick = (videoId) => {
    setSelectedVideoId(videoId);
    setPlayVideo(true); // Set to true to play the video
    setCard(false);
  };

  const setMusic = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-ytid/${id}`, { yt_id: selectedVideoId, start_time: startTime })
      .then(response => {
          console.log(response.data.message); 
          setCard(true);
      })
      .catch(error => {
          console.error('Error updating music:', error);
      });
  };

  const convertToSeconds = (time) => {
    if (time.includes(':')) {
      const [minutes, seconds] = time.split(':').map(Number);
      return minutes * 60 + seconds;
    } else {
      return Number(time);
    }
  };

  const handleStartTimeChange = (e) => {
    const value = e.target.value;
    if (/^\d+(:\d{2})?$/.test(value)) { // validate MM:SS or SS format
      const seconds = convertToSeconds(value);
      setStartTime(seconds);
    } else {
      setStartTime(0); // reset if the input is invalid
    }
  };

  const opts = {
    playerVars: {
      autoplay: 1, // Autoplay the video
    },
  };

  return (
    <div>
      {playVideo && (
        <div className="mt-4">
          <ResponsiveEmbed
            src={`https://www.youtube.com/embed/${selectedVideoId}?start=${startTime}`}
            autoPlay
            allowFullScreen
          />
        </div>
      )}
      <button
        onClick={setMusic}
        className='w-full rounded-lg my-4 text-black font-bold capitalize px-5 py-3 bg-yellow-400 hover:bg-yellow-500'
      >
        {t.useThis}
      </button>
      {card && (
        <a
          href={cardUrl}
          target="_blank"
          rel="noreferrer"
          className='btn-primary block text-center w-full rounded-lg mb-4 font-bold capitalize px-5 py-3'
        >
          {t.view}
        </a>
      )}
      <div className="flex mt-2">
        <input
          type="text"
          id="youtubeUrl"
          value={url}
          placeholder={t.enterYoutubeLink}
          onChange={(e) => setUrl(e.target.value)}
          className="flex-1 p-2 border-b border-gray-300 focus:outline-none focus:border-blue-500"
        />
        <button
          onClick={extractVideoId}
          className="btn-primary ml-2 px-4 py-2 rounded"
        >
          {t.play}
        </button>
      </div>
      <div className='flex'>
        <label className='flex py-2'>{t.startAt}</label>
        <input
          type="text"
          placeholder='0:20'
          onChange={handleStartTimeChange}
          className="flex-1 p-2 border-b border-gray-300 focus:outline-none focus:border-blue-500"
        />
      </div>

      <div className="mt-4">
        <label htmlFor="videoButtons" className="text-gray-600">{t.ourSuggestions}</label>
        <div className="flex flex-wrap gap-2 mt-2">
          {videoIds.map((video) => (
            <button
              key={video.id}
              onClick={() => handleVideoButtonClick(video.id)}
              className="btn-tertiary px-4 py-2 rounded-full"
            >
              {video.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideoId;
